import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 31041 63789"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#2b2a29;stroke-width:701.482}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970061629520">
        <path
          d="M30690 50984V32868L15521 45220 351 32868v18116l15170 12353z"
          className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}
        />
        <path
          d="M30690 27966v-5914L15521 34405 351 22052v5914l15170 12352z"
          className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}
        />
        <path
          d="M30690 17275v-5914L15521 23714 351 11361v5914l15170 12352z"
          className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}
        />
        <path
          d="M30690 6650V737L15521 13090 351 737v5913l15170 12353z"
          className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
